export default {
  // 文章類型
  TYPE_ABOUT: 'about', // 關於我們
  TYPE_MANAGEMENT: 'management', // 營運治理
  TYPE_AUDIENCE: 'audience', // 觀眾服務
  TYPE_OTHERS: 'others', // 其他服務
}